import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createActionGroup, createFeature, createReducer, createSelector, on, props } from '@ngrx/store';
import { DrillSetInterface } from '../../+models';

export const NAME = 'drillSets';

export type State = EntityState<DrillSetInterface>;

export const adapter: EntityAdapter<DrillSetInterface> = createEntityAdapter<DrillSetInterface>();

export const initialState: State = adapter.getInitialState();

export const actions = createActionGroup({
  source: 'DrillSets',
  events: {
    // setAll (not upsert): the feature holds exactly the current bank's sets,
    // so the detail store can source its unfiltered rail list from here
    // without leaking sets from previously visited banks.
    'Set Drill Sets': props<{ drillSets: DrillSetInterface[] }>(),
  },
});

export const feature = createFeature({
  name: NAME,
  reducer: createReducer(
    initialState,
    on(actions.setDrillSets, (state, { drillSets }): State => adapter.setAll(drillSets, state))
  ),
});

// `createFeature` only derives selectIds/selectEntities from the EntityState
// keys, not the adapter's selectAll; expose it for the detail store's rail.
export const { selectAll } = adapter.getSelectors(feature.selectDrillSetsState);

/**
 * Null-safe name lookup: returns an empty string while the drill set
 * is not (yet) in the store, so route data (breadcrumbs) can't crash on it.
 *
 * Standalone props-selector: `createFeature`'s `extraSelectors` only accepts
 * single-argument selectors or selector factories.
 */
export const selectName = createSelector(
  feature.selectEntities,
  (entities, byId: { id: number }): string => entities[byId.id]?.name ?? ''
);
